import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';

export class SignalR {
    private url: string;
    private connected: boolean;
    private connection: HubConnection;

    constructor(url: string, jwtToken: string) {
        this.connected = false;
        this.url = url;
        this.connection = new HubConnectionBuilder()
            .withUrl(this.url, {
                withCredentials: false,
                headers: {
                    Authorization: `Bearer ${jwtToken}`
                },
                accessTokenFactory: function() {
                    return jwtToken;
                }
            }).withAutomaticReconnect([1000, 3000, 6000, 9000, 15000, 20000])
            .build();

        this.start();
    }

    onReconnected(callback: () => void){
        this.connection.onreconnected(() => {
            console.log('Reconectado');

            callback();
        });
    }

    async start() {
        await this.connection.start();
        this.connected = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listen(event: string, callback: (...args: any[]) => void) {
        this.connection.on(event, callback);
    }

    async stop() {
        await this.connection.stop();
        this.connected = false;
    }

    joinGroup(groupName: string): Promise<void> {
        return new Promise((resolve) => {
            const attempt = async () => {
                if (!this.connected) {
                    console.log(`[SignalR] joinGroup('${groupName}') — not connected, retrying in 1s...`);
                    setTimeout(attempt, 1000);
                    return;
                }

                console.log(`[SignalR] joinGroup('${groupName}') — joining...`);
                await this.connection.invoke('JoinGroup', groupName);
                console.log(`[SignalR] joinGroup('${groupName}') — joined.`);
                resolve();
            };

            attempt();
        });
    }
}
